import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgEnlarge32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M13.095 4a9.095 9.095 0 0 1 6.778 15.158l7.98 7.98a.506.506 0 0 1-.716.715l-7.978-7.98A9.094 9.094 0 1 1 13.095 4m0 1.01a8.084 8.084 0 1 0 0 16.17 8.084 8.084 0 0 0 0-16.17m4.042 7.58a.506.506 0 0 1 0 1.01H9.053a.505.505 0 0 1 0-1.01zM13.6 17.136a.505.505 0 1 1-1.01 0V9.053a.505.505 0 1 1 1.01 0z" /></SvgIcon>;
};
const Memo = memo(SvgEnlarge32);
export default Memo;